<template>
    <h3 class="mt-6 text-lg sm:text-xl font-semibold sm:tracking-tight">
        <slot></slot>
    </h3>
</template>
